import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../core/form/Table';
import AudioPreview from '../../../core/layout/AudioPreview';
import { get } from 'lodash';
import { KPI_GREEN, KPI_RED } from '../../../core/chart/colors';
import Icon from '../../../core/layout/Icon';
import ImagePreview from '../../../core/layout/ImagePreview';

export default function PlacementTestReportTestDialogAnsweredQuestionListItem(props) {
  return (
    <div style={{ padding: '10px' }}>
      <ul style={{ listStyleType: 'none', margin: 0, padding: 0 }}>
        <li style={{ maxWidth: 'calc(100vw * 0.3)' }}>
          <div style={{ marginBottom: '12px', display: 'flex' }}>
            <span
              style={{
                width: '110px',
                display: 'inline-block',
                textAlign: 'right',
                fontWeight: 'bold',
                marginRight: '12px',
              }}
            >
              Student Answer:
            </span>
            <span style={{ width: 'calc(100% - 140px)' }}>
              {['UNSCRAMBLE_DRAG_AND_DROP', 'GAP_FILL_MULTIPLE', 'GAP_FILL_SELECT'].some(
                (type) => type === props.data.item.type.key
              )
                ? props.data.answer
                    .split(' ')
                    .map((slice) =>
                      !!props.data.item.answers.find((answer) => answer.text === slice) ? (
                        <u style={{ marginRight: '4px', whiteSpace: 'nowrap' }}>{slice}</u>
                      ) : (
                        <span style={{ marginRight: '4px', whiteSpace: 'nowrap' }}>{slice}</span>
                      )
                    )
                : props.data.answer}
            </span>
          </div>
        </li>
        <li>
          <div style={{ marginBottom: '12px', display: 'flex' }}>
            <span
              style={{
                width: '110px',
                display: 'inline-block',
                textAlign: 'right',
                fontWeight: 'bold',
                marginRight: '12px',
              }}
            >
              Item Type:
            </span>
            <span style={{ width: 'calc(100% - 140px)' }}>{props.data.item.type.name}</span>
          </div>
        </li>
        <li>
          <div style={{ marginBottom: '12px', display: 'flex' }}>
            <span
              style={{
                width: '110px',
                display: 'inline-block',
                textAlign: 'right',
                fontWeight: 'bold',
                marginRight: '12px',
              }}
            >
              Item Text:
            </span>
            <span style={{ width: 'calc(100% - 140px)' }}>{props.data.item.text}</span>
          </div>
        </li>
        <li>
          <div style={{ marginBottom: '12px', display: 'flex' }}>
            <span
              style={{
                width: '110px',
                display: 'inline-block',
                textAlign: 'right',
                fontWeight: 'bold',
                marginRight: '12px',
              }}
            >
              Item Audio:
            </span>
            {props.data.item.audio ? <AudioPreview src={props.data.item.audio} /> : '-'}
          </div>
        </li>
        <li>
          <div style={{ display: 'flex' }}>
            <span
              style={{
                width: '110px',
                display: 'inline-block',
                textAlign: 'right',
                fontWeight: 'bold',
                marginRight: '12px',
              }}
            >
              Item Options:
            </span>
            {get(props.data.item, 'answers', []).length > 0 ? (
              <Table
                columns={[
                  {
                    label: 'Answer',
                    path: 'text',
                  },
                  {
                    label: 'Correct',
                    path: 'correct',
                    render: (correct) => (
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Icon name={correct ? 'check' : 'close'} style={{ color: correct ? KPI_GREEN : KPI_RED }} />
                      </div>
                    ),
                  },
                  {
                    label: 'Image',
                    path: 'image',
                    render: (value) => (value ? <ImagePreview src={value} /> : '-'),
                  },
                  {
                    label: 'Audio',
                    path: 'audio',
                    render: (value) => (value ? <AudioPreview src={value} /> : '-'),
                  },
                ]}
                rows={props.data.item.answers}
              />
            ) : (
              '-'
            )}
          </div>
        </li>
      </ul>
    </div>
  );
}

PlacementTestReportTestDialogAnsweredQuestionListItem.propTypes = {
  data: PropTypes.object.isRequired,
};
